export const dateTimeFormats = {
    TWO_DIGIT: '2-digit',
    NUMERIC: 'numeric',
};
